import { render, staticRenderFns } from "./AdminErrorNotificationForm.vue?vue&type=template&id=917c23b0&scoped=true&"
import script from "./AdminErrorNotificationForm.vue?vue&type=script&lang=js&"
export * from "./AdminErrorNotificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917c23b0",
  null
  
)

export default component.exports